import React, { useRef } from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const Header = () => {
  const heroRef = useRef(null);

  const handleMouseMove = (e) => {
    const card = heroRef.current;
    if (!card) return;

    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = (y - centerY) / 60;
    const rotateY = (centerX - x) / 60;

    card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1, 1, 1)`;
  };

  const handleMouseLeave = () => {
    const card = heroRef.current;
    if (!card) return;
    card.style.transform = `perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)`;
  };

  return (
    <section className="hero-section">

      {/* Gradient Blur Background */}
      <div className="hero-blur-bg"></div>

      <div className="container hero-container">
        <div
          ref={heroRef}
          className="hero-content"
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
        >

          <h1 className="hero-title">
            Innovating <span className="bold-text">Technology.</span>  <br />
            <span className="italic-text">with Transforming Operations.</span>
          </h1>

          <p className="hero-subtitle">
            We build intelligent, future-ready digital solutions that streamline examinations, automate workflows, and empower organizations to perform at their best.
          </p>

          {/* CTA Section */}
          <div className="hero-cta">

            <Link to="/contact" className="cta-button">
              <span>Get Started</span>
              <div className="cta-icon">
                <ArrowUpRight size={20} />
              </div>
            </Link>

            <div className="trust-section">
              <div className="avatar-group">
                <img src="./images/logos/Dr._B.R._Ambedkar_University,_Srikakulam_logo.png" alt="" />
                <img src="./images/logos/DAMODARAM-SANJIVAYYA-NATIONAL-LAW-UNIVERSITY-VISAKHAPATNAM.png" alt="" />
                <img src="./images/logos/Andhra-Kesari-University-ONGOLE.jpg" alt="" />
                <img src="./images/logos/ANDHRA-UNIVERSITY-VISAKHAPATNAM.jpg" alt="" />
              </div>

              <div className="rating">
                <div className="stars">★★★★★</div>
                <p>Trusted by 1000+ clients</p>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default Header;